import { Component } from '@angular/core';

@Component({
    selector: 'app-not-found',
    imports: [],
    templateUrl: '../../../../assets/errors/404.html'
})
export class NotFoundComponent {}
